export const enum UserProfileActionsNames {
    FetchInfo = "fetchUserInfo",
    SetUserInfoState = "setUserInfoState",
    ResetState = "resetUserInfoState",
}

export const enum UserProfileMutationsNames {
    SetInfo = "setUserInfo",
    SetError = "setUserError",
    ResetState = "resetState",
}

export const enum UserProfileGettersNames {
    GetInfo = "userInfo",
    IsAuthenticated = "isAuthenticated",
    UserError = "userError",
}
